export default "__VITE_ASSET__CnKySB5N__"